import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FormattedDate, intlShape } from 'react-intl'
import { Link } from 'react-router'
import * as shapes from '../../constant/shapes'
import MiniPlayer from '../../components/miniPlayer/MiniPlayer'
import { ORIGIN_PLAYQUEUE_TYPES } from '../../components/miniPlayer/AudioPlayer/playerConstants'
import cx from 'classnames'

import hiResLogo from '../../resources/img/logo-hires.png'

const AlbumCard = (props, context) => {
	const { forceCardHeight, forceImageHeight, album, current, playing, GTMPlayEvent } = props
	const { id, title, release_date_original, image, artist, hires, genre } = album
	const { intl } = context

	return (
		<article
			className={`card ${current ? (playing ? 'isPlaying' : 'isPause' ) : ''}`}
			style={forceCardHeight ? { height: forceCardHeight } : {}}
		>
			<div className="card__container">
				<img
					className="card__image"
					src={image}
					style={forceImageHeight ? { height: forceImageHeight } : { height: forceImageHeight}}
					alt={title}
				/>
				<div className="card__action">
					<div className="card__infos">
						{genre && <span className="card__genre">{intl.formatMessage({ id: `genre.genre-id-${genre.id}` })}</span>}
						<span className="card__date">
							<FormattedDate
								value={new Date(`${release_date_original}T00:00:00`)}
								day="numeric"
								month="short"
								year="numeric"
							/>
						</span>
					</div>
					<Link className="card__linker" to={`/album/${id}`} />
					<MiniPlayer
						buttonClassName="card__button"
						element={album}
						GTMPlayEvent={GTMPlayEvent}
						type={ORIGIN_PLAYQUEUE_TYPES.album}
						sampleable={album.sampleable}
					/>
				</div>
			</div>

			<div className={cx("card__meta", {"card__meta--no-hires" : !hires})}>
				<h3 className="card__title" title={title}>
					<Link className="card__link" to={`/album/${id}`}>{title}</Link>
				</h3>
				<p className="card__subtitle" title={artist.name}>
					<Link className="card__link" to={`/artist/${artist.id}`}>{artist.name}</Link>
				</p>
				{hires && <img className="card__quality" src={hiResLogo} alt={intl.formatMessage({ id: 'infos.hires' })} height="40" width="40" />}
			</div>
		</article>
	)
}

AlbumCard.propTypes = {
	forceCardHeight: PropTypes.number,
	forceImageHeight: PropTypes.number,
	current: PropTypes.bool,
	playing: PropTypes.bool,
	album: shapes.albumCard,
	GTMPlayEvent: PropTypes.string
}

AlbumCard.contextTypes = {
	intl: intlShape
}

export default AlbumCard



// WEBPACK FOOTER //
// ./src/pages/artist/AlbumCard.jsx